<template>
  <div class="header-container">
    <header class="header-m">
      <div class="logo" @click="toggleCollapse">
        <img :src="require('@/assets/img/rebit_logo_noBG.png')" class="logo-img" />
        <i class="el-icon el-icon-arrow-down"></i>
      </div>
      <div class="right-container">


        <div class="chain-selector" @click.stop="platformChange">
          {{ selectedPlatform.shortName}}
          <i v-if="!disablePltBtn" class="el-icon-arrow-down"></i>
          <i v-else class="el-icon-close"></i>
        </div>

        <div class="lang" @click="LanguageChange">
          <span>{{ langList[Language].name }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>

        <div class="account">
          <div class="login" v-if="!login"  @click.stop="handleShow">{{ $t("lang.Login") }}</div >
          <div class="icon" v-else @click.stop="showPopup">
            <img  :src="avatar ? avatar:require('@/assets/avatar.jpg') " class="default-img" />
          </div>
        </div>

      </div>
    </header>
    <nav class="custom-nav" :class="{ collapse: isShow, 'nav-account':menuShow==1&&isShow }">
      <el-menu
        :default-active="customActive"
        @select="(e)=>handleOpen(e, menuShow)"
        background-color="rgba(50,50,50,.8)"
        text-color="#fff"
      >
        <div v-if="menuShow==0">
          <div v-show="menu1">
            <el-menu-item index="0" route="home-m">{{$t("lang.home") }}</el-menu-item>
            <el-menu-item index="7" route="pickMarket-m">{{$t("lang.ranking") }}</el-menu-item>
            <el-menu-item index="1" route="pickMarket-m">{{$t("lang.opting") }}</el-menu-item>
            <el-menu-item index="2" route="tradingMarket-m">{{$t("lang.market") }}</el-menu-item>
            <el-menu-item index="8" route="homeIndex-m">{{$t("lang.create")}}</el-menu-item>
            <el-menu-item index="3" route="mine-m">{{$t("lang.mine")}}</el-menu-item>
            <!-- <el-menu-item index="4" :class="{ 'is-active': customActive == '4-1' || customActive == '4-2' || customActive == '4-3', }" >{{$t("lang.Airdrop")}}</el-menu-item > -->
            <el-menu-item index="5">{{ $t("lang.whitePaper") }}</el-menu-item>
            <el-menu-item index="6">{{ $t("lang.install") }}</el-menu-item>
          </div>
          <div v-show="!menu1">
            <el-menu-item
              index="4-1"
              :class="{ 'is-active': customActive == '4-1' }"
              >{{$t("lang.Tasks")}}</el-menu-item
            >
            <el-menu-item
              index="4-2"
              :class="{ 'is-active': customActive == '4-2' }"
              >{{$t("lang.Ranking")}}</el-menu-item
            >
            <el-menu-item
              index="4-3"
              :class="{ 'is-active': customActive == '4-3' }"
              >{{$t("lang.ClaimRTV")}}</el-menu-item
            >
          </div>
        </div>
        <div v-else-if="menuShow==1">
          <el-menu-item index="0">Dashboard</el-menu-item>
          <el-menu-item index="1">Security</el-menu-item>
          <el-menu-item index="2">Identification</el-menu-item>
          <el-menu-item index="3">Payment</el-menu-item>
          <el-menu-item index="4">Fund</el-menu-item>
          <el-menu-item index="5">Withdrawal</el-menu-item>
          <el-menu-item index="6">Transaction</el-menu-item>
        </div>
      </el-menu>
    </nav>
    <el-drawer
      custom-class="sort-drawers"
      :visible.sync="visible"
      direction="btt"
      :size="165"
      :with-header="false"
    >
      <div class="sort-mod">
        <ul>
          <li
            v-for="(v, i) in langList"
            :key="i"
            :class="{ active: Language == i }"
            @click="handleSort(i)"
          >
            {{ v.name }}
          </li>
        </ul>
      </div>
    </el-drawer>
    <!-- 任务弹窗 -->
    <el-drawer
      custom-class="sort-drawers"
      :visible.sync="showDrawer"
      direction="btt"
      :size="365"
      :with-header="false"
    >
      <div class="box">
        <h4>
          <div>
            <span v-if="address && address.length > 10">{{
              address.substr(0, 8) +
              "...." +
              address.substr(address.length - 6, 8)
            }}</span>
            <i
              class="el-icon-copy-document"
              v-clipboard:copy="address"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            ></i>
          </div>
          <span class="Copied" v-if="showCopy"
            >Copied<i class="el-icon-check"></i
          ></span>
        </h4>
        <div class="nav">
          <ul>
            <li>
              <img src="@/assets/img/icon.png" alt="" />
              <div>
                <span>Balance</span>
                <h4>
                  <img src="@/assets/img/ETH.png" alt="" />
                  <span :title="Balance.ETH">{{ Balance.ETH }}</span>
                </h4>
              </div>
            </li>
            <li>
              <img src="@/assets/img/favicon.png" alt="" />
              <div>
                <h4>
                  <img src="@/assets/img/RTV.png" alt="" />
                  <span :title="Balance.RTV">{{ Balance.RTV }}</span>
                </h4>
              </div>
            </li>
          </ul>
          <div class="Dashboard" @click="handleClick">Dashboard</div>
        </div>
        <!-- 任务列表 -->
        <section>
          <h4>
            <span>{{ $t("lang.taskDetail") }}： </span>
            <span class="more" @click="handleTask">More tasks</span>
          </h4>
          <div class="order-by"> 
            <div
              class="container-box"
              :class="{ mintBox: object.dalily_can_reward == 3 }"
            >
              <div class="title">
                <p>
                  <span class="circle"></span>
                  <span>{{ $t("lang.reward") }}</span>
                </p>
                <p>{{ object.complete ? "1" : "0" }}/1</p>
              </div>
              <ul>
                <li>
                  <div>
                    <span :class="{ active: object.is_mint }">- {{$t("lang.mint")}}</span>
                    <i class="el-icon-check" v-show="object.is_mint"></i>
                  </div>
                  <div class="success" v-show="object.is_mint"></div>
                </li>
                <li>
                  <div>
                    <span :class="{ active: object.is_publish }">
                      - {{$t("lang.publish")}}</span
                    >
                    <i class="el-icon-check" v-show="object.is_publish"></i>
                  </div>
                  <div class="success" v-show="object.is_publish"></div>
                </li>
                <li>
                  <div>
                    <span :class="{ active: object.is_sell }">- {{$t("lang.sell")}}</span>
                    <i class="el-icon-check" v-show="object.is_sell"></i>
                  </div>
                  <div class="success" v-show="object.is_sell"></div>
                </li>
              </ul>
              <div class="Reward">
                <p>
                  <span>{{$t("lang.Reward")}}：</span>
                  <span class="number">1 RTV</span>
                </p>
              </div>
            </div>
            <div class="container-box">
              <div class="title">
                <p>
                  <span class="circle"></span>
                  <span>{{$t("lang.dailyReward")}}</span>
                </p>
                <p>{{ object.dalily_can_reward }}/3</p>
              </div>
              <ul>
                <li>
                  <div>
                    <span>- {{$t("lang.NumberVotes")}}</span>
                  </div>
                  <div>{{ object.dalily_vote_count }}/90</div>
                </li>
              </ul>
              <div class="Reward">
                <p>
                  <span>{{ $t("lang.reward") }}：</span>
                  <span class="number">1 RTV</span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </el-drawer>
    <nav class="custom-navList" :class="{ collapse: showUp, 'nav-account':showUp }">
      <el-menu :default-active="customActive"   background-color="rgba(50,50,50,.8)" text-color="#fff" >
        <div >
          <div >
            <el-menu-item index="0" @click="jump(8)" >{{$t("lang.PersonalCenter")}}</el-menu-item>
            <el-menu-item index="1" @click="jump(0)" >{{$t("lang.Dashboard")}}</el-menu-item>
            <el-menu-item index="2" @click="jump(1)" >{{$t("lang.Security")}}</el-menu-item>
            <el-menu-item index="3" @click="jump(2)" >{{$t("lang.Identification")}}</el-menu-item>
            <el-menu-item index="4" @click="jump(3)" :class="{'active':!enabledRecharge}" >{{$t("lang.Payment")}}</el-menu-item >
            <el-menu-item index="5" @click="jump(4)">{{$t("lang.Fund")}}</el-menu-item>
            <el-menu-item index="6" @click="jump(5)" :class="{'active':!enabledWithdrawal}">{{$t("lang.withdraw")}}</el-menu-item>
            <el-menu-item index="7" @click="jump(6)">{{$t("lang.Transaction")}}</el-menu-item>
            <el-menu-item index="9" @click="jump(9)">{{$t("lang.announcement")}}</el-menu-item>
            <el-menu-item index="10" @click="jump(10)">{{$t("lang.feedback")}}</el-menu-item>
            <el-menu-item index="11" @click="jump(11)">{{$t("lang.teamwork")}}</el-menu-item>
            <el-menu-item index="8" @click="jump(7)">{{$t("lang.logout")}}</el-menu-item>
          </div>
          
        </div>
       
      </el-menu>
    </nav>
    <!--    多平台弹窗-->
    <el-drawer
        custom-class="sort-drawers"
        :visible.sync="showPlatform"
        direction="btt"
        :size="165"
        :with-header="false"
    >
      <div class="sort-mod">
        <ul>
          <li
              v-for="(v, i) in platforms"
              :key="i"
              :class="{ active: selectedPlatform.fullName === v.fullName }"
              @click="handlePlatformDropdown(v.shortName)"
          >
            <span v-if="v.shortName == 'ETH' "> {{ v.fullName }} </span>
            <span v-else-if="v.shortName == 'CFX' "> {{ v.fullName }} | 1 ETH = {{cfxRate}} {{ v.shortName }}</span>
            <span v-else> {{ v.fullName }} | 1 ETH = {{btyRate}} {{ v.shortName }}</span>
          </li>

        </ul>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import ad from "@/utils/web3Helper.js";
import request from "@/services/request";
import {doc,install} from "@/config.js"
import { mapState } from "vuex";
import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import zhTW from 'vant/es/locale/lang/zh-TW';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet} from '@/api/api';
import EventBus from '@/utils/EventBus'
import {isPc} from "@/utils";
import {getChainProperty} from "@/lib/multiChain";
export default {
  name: "mobileHeader",
  props: {
    disablePltBtn: {
      type: Boolean,
      default: true,
    },
    customActive: {
      default: "0",
      type: String,
    },
    menuShow:{
      default:0,
      type:Number,
    },
    forceLogin:{
      default: "1",
      type: String,
    }
  },
  data() {
    return {
      devEnv: process.env.NODE_ENV === "development",
      cfxRate: 0,
      btyRate: 0,
      isShow: false,
      visible: false,
      showUp:false,
      api:BASE_GLOB_API,
      langList: [
        // {name:"中文",value:"zh"},
        { name: "English", value: "en" },
        { name: "日本語", value: "ja" },
        { name: "한국어", value: "ko" },
        { name: "繁體中文", value: "cn" },
      ],
      url:{
          logout:BASE_GLOB_API+'/login/logout',
        platform:BASE_GLOB_API+'/kanban/coin/platform',
          },
      Language: "0",
      menu1: true,
      showDrawer: false,
      showCopy: false,
      showPlatform: false,
      Balance: {},
      object: {},
      login:false,
      userinfo:{},
      avatar:'',
      enabledRecharge:true,
      enabledWithdrawal:true,
      platforms:[],
      selectedPlatform: {},
    };
  },
  computed: {
    ...mapState(["address"]),
    account() {
      let address = this.address;
      if (address && address.length > 10) {
        return (
          address.substr(0, 5) + "...." + address.substr(address.length - 4, 4)
        );
      } else {
        return false;
      }
    },
    ethereumAddress() {
      return this.$store.state.ethereumAddress;
    },
  },
  created() {
    if (window.ethereum) {
      setTimeout(() => {
        console.log(this.ethereumAddress);
        let token = sessionStorage.getItem("Token");
        if (!token && this.ethereumAddress.toString() == "true") {
          sessionStorage.setItem("iSsignature", false);
          this.getSign();
        }
      }, 1000);
      ad.init();
    }
    let lang = sessionStorage.getItem("Language");
    console.log("lang33",lang)
    if (lang) {
      this.langList.forEach((item, index) => {
        if (item.value == lang) {
          this.Language = index;
        }
      });
    }else{
        this.$i18n.locale = 'en';
        Locale.use('en-US', enUS);
    }
    let token = localStorage.getItem("Token");
    if(token){
      this.login =true;
      this.userinfo =JSON.parse(sessionStorage.getItem("userinfo")) ;
      this.getBtPlatform();
     if(this.userinfo.avatar){
      this.avatar =this.api + this.userinfo.avatar
     }else{
      this.avatar =''
     }
    }else{
      console.log("this.forceLogin",this.forceLogin)
      if (this.forceLogin === "1") {
        this.$message.error(this.$t("lang.loginTip"));
        this.$router.push({name:'login-m'});
        this.login =false
      }
    }
    EventBus.$on('img', value => {
      // 将 A 组件传递过来的数据保存到 B 组件
           if(value){
              this.userinfo =JSON.parse(sessionStorage.getItem("userinfo")) ;
              if(this.userinfo.avatar){
              this.avatar =this.api + this.userinfo.avatar
              }else{
              this.avatar =''
              }
           }

    })
      EventBus.$on('enabledRecharge', value => {
      
      this.enabledRecharge =value;
    })
      EventBus.$on('enabledWithdrawal', value => {

       this.enabledWithdrawal =value;
    
    })
  },
  mounted() {
    // document.addEventListener("click", (e) => {
    //   if (!this.$el.contains(e.target)) {
    //     this.isShow = false;
    //   }
    // });
  },
  methods: {
    jump(i){
      if (i == 0) {
          this.$router.push({name:"dashboard-m"});
        }else if(i == 1){
          this.$router.push({name:"security-m"});
        }else if(i == 2){
          this.$router.push({name:"identification-m"});
        }else if(i == 3){
          if(this.enabledRecharge){
            this.$router.push({name:"payment-m"});
          }
        }else if(i == 4){
          this.$router.push({name:"fund-m"});
        }else if(i == 5){
          if(this.enabledWithdrawal){
               this.$router.push({name:"withdrawal-m"});
          }
        }else if(i == 6){
          this.$router.push({name:"transaction-m"});
        }else if(i == 7){
          this.Logout()
        }else if(i == 8){
          this.$router.push({name:"center-m"});
        }else if(i == 9){
          this.$router.push({name:"userFeedback-m"});
        }else if(i == 10){
          this.$router.push({name:"Feedback-m"});
        }else if(i == 11){
          this.$router.push({name:"teamwork-m"});
        }
        
        this.showUp = false;
    },
    showPopup() {
      console.log("1",1)
      let selected = JSON.parse( sessionStorage.getItem("selectedNet"));
      if(selected){
          this.enabledRecharge=selected.enabledRecharge
          this.enabledWithdrawal=selected.enabledWithdrawal
          EventBus.$emit('enabledRecharge',  this.enabledRecharge);
          EventBus.$emit('enabledWithdrawal', this.enabledWithdrawal);
        }
      this.showUp = !this.showUp;
      this.isShow = false;
    },
    Logout(){
      axiosGet(this.url.logout).then(res=>{
          if(res.code ==200){
            this.$router.push({name:'login-m'});
            window.sessionStorage.clear();
            window.localStorage.clear();
          }else{
              this.$message.error(res.message);
          }
      })
           
    },
    handleClick() {
      sessionStorage.setItem("scroll", "false");
      let urlName = this.$route.name;
      if (urlName == "personal") {
        this.$emit("close");
      } else {
        this.$router.push({
          name: "personal-m",
        });
      }
    },
    handleTask() {
      let urlName = this.$route.name;
      if (urlName == "task") {
        this.$emit("close");
      } else {
        this.$router.push({
          name: "task",
        });
      }
    },
    getList() {
      this.getTask();
      this.getBalance();
    },
    getTask() {
      request
        .getTaskDetail({
          address: this.address,
        })
        .then((res) => {
          if (res.code == 200) {
            this.object = res.data;
          }
        });
    },
    getBalance() {
      request.getBalance({ address: this.address }).then((res) => {
        if (res.code == 200) {
          this.Balance = res.data;
        }
      });
    },
    onCopy(e) {
      this.showCopy = true;
      setTimeout(() => {
        this.showCopy = false;
      }, 2000);
      // this.$message.success(this.$t("lang.copy"));
    },
    onError(e) {
      // this.$message.error(this.$t("lang.copyError"));
    },
    handleShow() {
      let token = sessionStorage.getItem("Token");
      console.log("token",token)
      if (!token) {
        // sessionStorage.setItem("iSsignature", false);
        // this.getSign();
        this.$router.push({name:'login-m'});  
      } else {
        this.$router.push({name:'account-m'});
        // this.getList();
        // this.visible = false; //关闭其他的弹窗
        // this.showDrawer = true;
      }
    },
    handleOpen(i, type) {
      console.log("isShow:", this.isShow)
      console.log("i:", i)
      console.log("type:",type)
      if(type == 0){
        if (i == 0) {
          this.$router.push({name:"home-m"});
        }
        if (i == 1) this.$router.push({name:"pickMarket-m"});
        if (i == 2) this.$router.push({name:"tradingMarket-m"});
        if (i == 3) this.$router.push({name:"mine-m"});
        if (i == 7) this.$router.push({name:"ranking-m"});
        if (i == 8) this.$router.push({name:"homeIndex-m"});
        if (i == 4) this.menu1 = false;
        if (i == 5) {
          window.open(doc);
          this.toggleCollapse();
        };
        if (i == 6) {
          window.open(install);
          this.toggleCollapse();
        };
        if (i == "4-1") {
          this.$router.push({
            name: "task-m",
          });
        }
        if (i == "4-2") {
          this.$router.push({
            name: "rank-m",
          });
        }
        if (i == "4-3") {
          this.$router.push({
            name: "personal-m",
          });
        }
      }else if(type == 1){
        if (i == 0) {
          this.$router.push({name:"dashboard-m"});
        }
        if (i == 1) this.$router.push({name:"security-m"});
        if (i == 2) this.$router.push({name:"identification-m"});
        if (i == 3) this.$router.push({name:"payment-m"});
        if (i == 4) this.$router.push({name:"fund-m"});
        if (i == 5) this.$router.push({name:"withdrawal-m"});
        if (i == 6) this.$router.push({name:"transaction-m"});
        this.isShow = false;
      }
      
      console.log(i);
    },
    LanguageChange() {
      this.visible = true;
    },
    platformChange(){
      if (this.disablePltBtn) {
        this.$message.error(this.$t("lang.canNotChange"));
      } else {
        this.showPlatform = true;
      }

    },
    handleSort(i) {
      this.Language = i;
      console.log("3",i)
      let lang = this.langList[i].value;
      this.$i18n.locale = lang;
      sessionStorage.setItem("Language", lang);
      this.visible = false;
      if(lang == 'en'){
        Locale.use('en-US', enUS);
      }else if(lang == 'cn'){
        Locale.use('zh-TW', zhTW);
      }
      EventBus.$emit('share', lang);
    },
    toggleCollapse() {
      if (this.isShow) {
        this.menu1 = true;
      }
      this.isShow = !this.isShow;
      this.showUp = false;
    },
    hideMenu() {},
    handlePlatformDropdown(command) {

      this.platforms.forEach(item=>{
        if(item.shortName === command){
          let selectedPlatform = {
            enabled:item.enabled,
            fullName:item.fullName,
            icon:item.icon,
            id:item.id,
            shortName:item.shortName,
            unit:item.unit,
            networkVos:item.networkVos,
          }
          window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedPlatform)));
          this.selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
        }
      });
      this.showPlatform = false;
      this.$emit("platform");
      // console.log("selectedPlatform",this.selectedPlatform)
    },
    getBtPlatform() {
      request.getCfxRate().then(res=>{
        if(res.code == 200){
          this.cfxRate = res.result;
          sessionStorage.setItem("cfxRate", this.cfxRate);
          console.log("cfxRate",this.cfxRate)
        }else{
          // this.$message.error("cfxRate error");
        }
      })
      request.getBtyRate().then(res=>{
        if(res.code == 200){
          this.btyRate = res.result;
          sessionStorage.setItem("btyRate", this.btyRate);
          console.log("btyRate",this.btyRate)
        }else{
          // this.$message.error("cfxRate error");
        }
      })
      // if (this.devEnv) {
      //   this.cfxRate = 23456;
      //   sessionStorage.setItem("cfxRate", this.cfxRate);
      // }
      axiosGet(this.url.platform).then(res=>{
        if(res.code ==200){
          let date =res.result
          console.log("platFormData",date)
          if(date.length > 0){
            date.forEach(item=>{
              if(item.enabled && item.fullName !=="Revolution"){
                let source ={
                  enabled:item.enabled,
                  fullName:item.fullName,
                  icon:item.icon,
                  id:item.id,
                  shortName:item.shortName,
                  unit:item.unit,
                  networkVos:item.networkVos,
                }
                this.platforms.push(source)
              }
            });

            let selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
            if(selectedPlatform){
              console.log("selectedPlatform",selectedPlatform);
              // this.value =selectedPlatform.btPlatformId
              this.platforms.forEach(item=>{
                if(item.id === selectedPlatform.btPlatformId){
                  let selectedPlatformNew = {
                    enabled:item.enabled,
                    fullName:item.fullName,
                    icon:item.icon,
                    id:item.id,
                    shortName:item.shortName,
                    unit:item.unit,
                    networkVos:item.networkVos,
                  }
                  console.log("selectedMobile",selectedPlatformNew)
                  window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedPlatformNew)));
                }

              });
            }else{
              let selectedNetPc = {
                enabled:this.platforms[0].enabled,
                fullName:this.platforms[0].fullName,
                icon:this.platforms[0].icon,
                id:this.platforms[0].id,
                shortName:this.platforms[0].shortName,
                unit:this.platforms[0].unit,
                networkVos:this.platforms[0].networkVos,
              }
              window.sessionStorage.setItem("selectedPlatform", JSON.stringify(getChainProperty(selectedNetPc)));
            }
          }
          sessionStorage.setItem("platforms", JSON.stringify(this.platforms));
          this.selectedPlatform = JSON.parse( sessionStorage.getItem("selectedPlatform"));
        }else{
          this.$message.error(res.message);
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>

.chain-selector {
  position: relative;
  color: #000;
  margin-right: 10px;
  border: 1px solid #000;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 13px;
  display: flex;
  align-items: center;
  cursor: pointer;

  .chain-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }

  .el-icon-arrow-down {
    margin-left: 2px;
    font-size: 12px;
  }
}

.chain-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  z-index: 10;
  min-width: 120px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .chain-item {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }

    .chain-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
.drop-item {
  display: flex;
  align-items: center; /* 垂直居中 */
  /* 可选: 加点间距 */
  gap: 8px;
  /* 或者用 margin-right 给 img 加间距也行 */
}

.nft-drop-img{
  max-width: 24px;
  max-height: 24px;
  width: auto;
  height: auto;
  margin-right: 8px;
}

.header-container {
  .header-m {
    //background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    position: relative;
    z-index: 9;
    .logo {
      color: #000;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .logo-img {
        width: 104px;
      }
      .el-icon {
        font-size: 17px;
        margin-left: 4px;
        margin-top: 4px;
      }
    }
    .right-container {
      display: flex;
      align-items: center;
      .lang {
        color: #000;
        margin-left: 10px;
        border: 1px solid #000;
        padding: 3px 8px;
        border-radius: 4px;
        font-size: 13px;
        i {
          margin-left: 2px;
        }
      }
    }
    .account {
      // background: rgba(224, 224, 224, 0.27);
      height: 30px;
      border-radius: 10em;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 12px;
      font-size: 14px;
      .icon {
        width: 28px;
        height: 28px;
        //background: #fff;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
        .default-img {
          width: 100%;
          height: 100%;
        }
        .custom-img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        color: #000;
        text-decoration: underline;
      }
      .login{
        color: #000;
      }

    }
  }
  /deep/ .sort-drawers {
    .sort-mod {
      padding: 10px 20px;
      ul {
        li {
          text-align: center;
          font-size: 14px;
          border-bottom: 1px solid #eee;
          line-height: 35px;
          color: #333;
          &.active {
            color: #841ae9;
            font-weight: 600;
            font-size: 15px;
          }
        }
      }
    }
  }
  .custom-nav {
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
    position: absolute;
    z-index: 8;
    left: 0;
    right: 0;
    top: 40px;
    &.collapse {
      height: 450px;
    }
    &.nav-account {
      height:392px;
    }
    .el-menu-item {
      margin: 0;
      border-radius: 0;
      width: auto;
      &.is-active {
        color: #000000;
        line-height: 56px;
        height: 56px;
        background: linear-gradient(45deg, #f4d7f0 0%, #d7b0f4 100%);
      }
    }
  }
  .custom-navList {
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
    position: absolute;
    z-index: 8;
    left: 0;
    right: 0;
    top: 45px;
    &.collapse {
      height: 340px;
    }
    &.nav-account {
      height:670px;
    }
    .el-menu-item {
      margin: 0;
      border-radius: 0;
      width: auto;
      &.is-active {
        color: #000000;
        line-height: 56px;
        height: 56px;
        background: linear-gradient(45deg, #f4d7f0 0%, #d7b0f4 100%);
      }
      &.active{
        color: #161414;
        background: linear-gradient(45deg, #ccc 0%, #ccc 100%);
      }
    }
  }
  .box {
    padding: 10px 10px 0;
    & > h4 {
      width: 100%;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333;
      cursor: pointer;
      i {
        margin-left: 8px;
        font-size: 18px;
        color: #888;
      }
      .Copied {
        font-size: 13px;
        color: #35a330;
        display: flex;
        align-items: center;
        i {
          color: #35a330;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    .nav {
      ul {
        background: #f7f6f6;
        margin: 10px 0;
        padding: 10px;
        li {
          display: flex;
          align-items: flex-start;
          color: #333;
          padding-top: 5px;
          &:first-child {
            border-bottom: 1px solid #e7e7e7;
          }
          img {
            width: 35px;
            margin-right: 25px;
          }
          div {
            span {
              display: inline-block;
              font-size: 14px;
              color: #666;
            }
            h4 {
              font-size: 16px;
              line-height: 40px;
              display: flex;
              align-items: center;
              padding-right: 4px;
              img {
                width: 10px;
                margin-right: 6px;
              }
              span {
                display: inline-block;
                max-width: 170px;
                font-size: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #333;
              }
            }
          }
        }
      }
      .Dashboard {
        margin: 0 auto;
        background: #3c4897;
        line-height: 38px;
        font-size: 15px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        border-radius: 4px;
        &:hover {
          box-shadow: 0 0 15px 0px #ccc;
          background: #5461bb;
        }
      }
    }
    section {
      margin: 10px 0;
      h4 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #333;
        font-size: 14px;
        .more {
          color: #666;
          font-size: 13px;
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            color: #444;
          }
        }
      }
      .order-by {
        display: flex;
        flex-direction: column;
      }
      .container-box {
        margin: 10px 0;
        order: 2;
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 40px;
          p {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;
            font-weight: 600;
            span {
              color: #3c4897;
            }
            .circle {
              background: #3c4897;
              width: 16px;
              height: 16px;
              display: inline-block;
              border-radius: 8px;
              margin-right: 5px;
            }
          }
        }
        ul {
          padding: 5px 10px;
          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 30px;
            font-size: 13px;
            color: #666;
            i {
              margin-left: 5px;
              color: #35a330;
              font-size: 18px;
              font-weight: 600;
            }
            .success {
              color: #35a330;
              font-weight: 600;
            }
            span.active {
              color: #333;
              font-weight: 600;
            }
            &.desc {
              color: #666;
              line-height: 22px;
              display: block;
              span {
                font-weight: 600;
                color: #333;
                display: inline-block;
                margin-right: 2px;
              }
            }
          }
        }
        .Reward {
          display: flex;
          justify-content: flex-end;
          line-height: 35px;
          margin-top: 5px;
          p {
            background: #e2e6ff;
            text-align: center;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            padding: 0 15px;
            .number {
              color: #3c4897;
            }
          }
        }
      }
      .mintBox {
        order: 3;
      }
    }
  }
  .overlay-class{
    // color: rgb(255, 255, 255);
    // background-color: rgba(50, 50, 50, 0.8);
    // margin-top: 45px;
  .tabList{
    .vanCell{
      &.active{
          background-color: #f4f5f6;
      }
      .cell{
        &.active{
          color: #ccc;
      }
      }
    }
 
  }
  }
  // .overlay-class{
  //   color: rgb(255, 255, 255);
  //   background-color: rgba(50, 50, 50, 0.8);
  //   margin-top: 45px;
  // }
}
//.custom-drawer {
//  .el-drawer__wrapper {
//    background-color: transparent !important;
//  }
//  .el-drawer__body {
//    background-color: #fff;
//  }
//}
// /deep/.el-drawer__wrapper {z-index:8 !important;}
// /deep/.custom-drawer.ttb {top:50px;}
</style>